import { CRMLabels } from '@dtx-company/true-common/src/types/crmThirdParty'
import { CheckboxProps, MaskType } from '@dtx-company/shared-components/src/types'
import { LinkType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { ReactNode } from 'react'
import { UseFormMethods } from 'react-hook-form-deprecated'
import { UseFormReturn } from 'react-hook-form'

export enum FormFields {
  TITLE = 'title',
  DESCRIPTION = 'description',
  FIELDS = 'fields',
  REQUIRED = 'required',
  DISPLAY_TYPE = 'displayType',
  CUSTOM_FIELD_LABEL = 'customFieldLabel',
  CUSTOM_FIELD_LABEL_2 = 'customFieldLabel2',
  CUSTOM_TERMS = 'customTerms',
  WIDGET_DISPLAY_TYPE = 'widgetDisplayType',
  ZAPIER = 'zapier',
  MAILCHIMP = 'mailChimp',
  GOOGLESHEETS = 'googleSheets',
  KLAVIYO = 'klaviyo',
  HUBSPOT = 'hubspot',
  IMAGE = 'thumbNailImgUrl',
  LINK = 'link',
  SUCCESS_MESSAGE = 'successMessage',
  FILLED_OUT_FORM_REQ = 'filledOutFormRequirement',
  DISABLE_CONFETTI = 'disableConfetti'
}
export interface ContactCollectionFields {
  displayName: boolean
  email: boolean
  phone: boolean
  address: boolean
  age: boolean
  gender: boolean
  custom: boolean
  custom2: boolean
}

export enum ContactCollectionFormDisplayTypes {
  EMBED = 'embed',
  POPUP = 'popup',
  DEFAULT = 'default'
}

export interface CustomTermsTypes {
  enabled: boolean
  disclaimer?: string
  pdf?: File | null | string
}

export interface ExternalCollectionService {
  enabled: boolean
  url?: string
  spreadsheetId?: string
  apiKey?: string | null // klaviyo and hubspot
  customListId?: string // klaviyo
  listId?: string // mailchimp
}

export interface SuccessMessage {
  enabled: boolean
  header?: string
  body?: string
}

export interface ContactCollectionForm {
  title: string
  description: string
  fields: ContactCollectionFields
  required: ContactCollectionFields
  customFieldLabel: string
  customFieldLabel2: string
  displayType: string
  widgetDisplayType: MaskType
  customTerms: CustomTermsTypes
  zapier: ExternalCollectionService
  mailChimp: ExternalCollectionService
  googleSheets: ExternalCollectionService
  klaviyo: ExternalCollectionService
  hubspot: ExternalCollectionService
  successMessage: SuccessMessage
  filledOutFormRequirement: boolean
  thumbNailImgUrl: string
  disableConfetti: boolean
}

export interface PreviewProps {
  values: ContactCollectionForm
}

export interface UseContactCollectionFormStateType {
  id: string
  handleSubmit: UseFormReturn<ContactCollectionForm>['handleSubmit']
  onSubmit: (e: any) => Promise<void>
  setValue: UseFormReturn<ContactCollectionForm>['setValue']
  watchAll: ContactCollectionForm
  disabled: boolean
  edit: boolean
  errors: UseFormReturn<ContactCollectionForm>['formState']['errors']
  linkTheme: LinkType['linkTheme']
  setLinkThemeValue: (linkThemeInput: Partial<LinkType['linkTheme']>) => void
  setError: UseFormReturn<ContactCollectionForm>['setError']
  clearErrors: UseFormReturn<ContactCollectionForm>['clearErrors']
}

export interface CustomTermsFileUploadTypes {
  setError: UseFormReturn<ContactCollectionForm>['setError']
  setValue: UseFormReturn<ContactCollectionForm>['setValue']
  clearErrors: UseFormReturn<ContactCollectionForm>['clearErrors']
  watchAll: ContactCollectionForm
  children?: ReactNode
}

export interface AuthGoogleSheetsResponse {
  authorizeGoogleSheets?: string
}

export interface ValidateGoogleSheetResponse {
  hasValidGooglesheetId?: boolean
}

export interface IntegrationInputConfig {
  label: CRMLabels
  checked: boolean
  iconSrc: string
  postScript?: string
  checkBoxOnChange: () => void
  disabled?: boolean
  gatedFeatureTooltipText?: string
  labelProps: CheckboxProps['labelProps']
  inputProps?: CheckboxProps['inputProps']
  tooltip?: { content: string }
  inputSection?: JSX.Element
}

export type IntegrationInputConfigArr = (IntegrationInputConfig | false | undefined)[]
export interface IntegrationsInputsArgs {
  formValues: ContactCollectionForm
  setValue: UseFormMethods['setValue']
  setError: UseFormMethods['setError']
  userHasOperations?: {
    view?: {
      hubspot_crm_option?: boolean
      klaviyo_crm_option?: boolean
    }
  }
  errors: UseFormMethods['errors']
}

export type CRMFeatureFlags = {
  isGSheetsEnabled: boolean
}
